export default __webpack_public_path__ + "static/media/maritime_background.c4edf8c6.jpg";